import { getEnvChain } from "../../env";

export default function useChain() {
  return getEnvChain();
}
